import { proxy } from 'valtio';
import { z } from 'zod';
import { fetchExternalUserInfoQuery } from '#/api/hooks/useUserInfo';

export { login, logout } from './navigation';

const authStateSchema = z.object({
  isAuthenticated: z.boolean(),
});

type AuthState = z.infer<typeof authStateSchema>;

const authState = proxy<AuthState>({
  isAuthenticated: false,
});

export async function checkAuthencationStatus() {
  try {
    const data = await fetchExternalUserInfoQuery();
    authState.isAuthenticated = !!data;
  } catch (error) {
    authState.isAuthenticated = false;
    console.error('failed to verify authentication status:', error);
  }
  return authState.isAuthenticated;
}
